import { cn } from "@/lib/cn";

function fmtBps(bps: number): string {
  if (bps < 1_000) return `${bps.toFixed(0)} b/s`;
  if (bps < 1_000_000) return `${(bps / 1_000).toFixed(0)} Kb/s`;
  if (bps < 1_000_000_000) {
    const mbps = bps / 1_000_000;
    if (mbps < 1000) {
      return `${mbps % 1 === 0 ? mbps.toFixed(0) : mbps.toFixed(1)} Mb/s`;
    }
  }
  const gbps = bps / 1_000_000_000;
  if (gbps < 1000) {
    return `${gbps % 1 === 0 ? gbps.toFixed(0) : gbps.toFixed(1)} Gb/s`;
  }
  return `${(gbps / 1000).toFixed(1)}k Gb/s`;
}

export function ChartStat({
  color,
  label,
  avg,
  max,
  min,
  isMuted,
  limit,
  showPercent,
}: {
  color: string;
  label: string;
  avg: number;
  max: number;
  min: number;
  isMuted?: boolean;
  limit?: number;
  showPercent?: boolean;
}) {
  const showPct = Boolean(showPercent && limit && limit > 0);
  const fmtMaybePercent = (value: number) => {
    if (!showPct || !limit || limit <= 0) return fmtBps(value);
    return `${fmtBps(value)} (${Math.round((value / limit) * 100)}%)`;
  };

  return (
    <div
      className={cn(
        "flex flex-col gap-1 rounded-lg border border-line/70 bg-surface-tint/20 px-3 py-2",
        isMuted && "opacity-45",
      )}
    >
      <div className="flex items-center gap-2">
        <span className={cn("inline-block h-2 w-2 rounded-full", color)} />
        <span className="text-fg-dim">{label}</span>
      </div>
      <div className="flex flex-wrap items-center gap-4">
        <span className="font-mono text-fg-mute">
          AVG <b className="text-fg">{fmtMaybePercent(avg)}</b>
        </span>
        <span className="font-mono text-fg-mute">
          PEAK <b className="text-fg">{fmtMaybePercent(max)}</b>
        </span>
        {limit && limit > 0 ? (
          <span className="font-mono text-fg-mute">
            LIMIT <b className="text-fg">{fmtBps(limit)}</b>
          </span>
        ) : (
          <span className="font-mono text-fg-mute">
            MIN <b className="text-fg">{fmtBps(min)}</b>
          </span>
        )}
      </div>
    </div>
  );
}
